export default {
  loading_menu: 'Menü laden...',
};
